export default __webpack_public_path__ + "static/media/IconPlus.942c14ee.svg";